import { svg } from "lit";
const icon = svg `<path d="M6.63075 35.0957L5 33.4649L18.5615 19.915L26.8153 28.1688L39.25 15.8111H32.4769V13.542H42.9999V24.065H40.7615V17.4726L26.7846 31.4688L18.5307 23.2149L6.63075 35.0957Z" fill="currentColor"/>`;
export default icon;
